import { render, staticRenderFns } from "./Operatsiya.vue?vue&type=template&id=35fb1b13"
import script from "./Operatsiya.vue?vue&type=script&lang=js"
export * from "./Operatsiya.vue?vue&type=script&lang=js"
import style0 from "./Operatsiya.vue?vue&type=style&index=0&id=35fb1b13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports